class LoadMore extends HTMLElement {
  constructor() {
    super();
    this.bindEvents = this.bindEvents.bind(this);
    this.loadMoreItems = this.loadMoreItems.bind(this);
  }
  connectedCallback() {
    this.loadMoreEl = this;
    this.containerId = this.loadMoreEl.dataset.container;
    this.itemsGridContainer = document.querySelector(`#${this.containerId}`);
    this.loadMoreBtn = this.querySelector(".js-load-more-btn");
    this.totalItemsViewed = this.querySelector(".js-total-items");
    this.loadMoreItems = this.loadMoreItems.bind(this);
    this.nextUrl = this.itemsGridContainer.dataset.nextUrl;
    this.bindEvents();
  }
  bindEvents() {
    if (this.nextUrl) {
      this.loadMoreBtn.addEventListener("click", this.loadMoreItems);
    }
  }
  async loadMoreItems() {
    this.loadMoreBtn.classList.add("button--loading");
    await fetch(`${this.nextUrl}&view=${this.containerId}`).then((response) => response.text()).then((html) => {
      history.pushState("", "", this.nextUrl);
      const DOM = new DOMParser().parseFromString(html, "text/html");
      const nextItemsViewed = DOM.querySelector(".js-total-items");
      const nextItemsGrid = DOM.querySelector(`#${this.containerId}`);
      if (nextItemsGrid) {
        this.itemsGridContainer.innerHTML += nextItemsGrid.innerHTML;
      }
      if (nextItemsViewed) {
        this.totalItemsViewed.innerHTML = nextItemsViewed.innerHTML;
      }
      window.lozadObserver.observe();
      this.loadMoreBtn.classList.remove("button--loading");
      let nextUrl = nextItemsGrid == null ? void 0 : nextItemsGrid.dataset.nextUrl;
      nextUrl = nextUrl.substring(0, nextUrl.indexOf("&view"));
      nextUrl ? this.nextUrl = nextUrl : this.loadMoreBtn.style.display = "none";
      const customEvent = new CustomEvent("listing-load-more:update");
      document.dispatchEvent(customEvent);
    }).catch(function(error) {
      this.loadMoreBtn.classList.remove("button--loading");
    });
  }
}
customElements.define("w3-load-more", LoadMore);
